// extracted by mini-css-extract-plugin
export default {"referralTable":"vz","referralHr":"wz","refBtn":"xz","refTableHeader":"yz","cta":"zz"};
    if(module.hot) {
      // 1738064238431
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  